import React from 'react';

import { companyContacts } from 'components/Contact-us/constants/company-contacts';
import { TitleSecond } from 'components/Titles';

import DepartmentContactsDetailed from './DepartmentContactsDetailed';

const ContactsOffices = () => {
  return (
    <div className="contacts-offices">
      <TitleSecond title="Our offices" />

      <div className="cities">
        <DepartmentContactsDetailed cityContacts={companyContacts.cities} />
      </div>
    </div>
  );
};

export default ContactsOffices;
